import React from 'react';
import {
  Box,
  FormGroup,
  Label,
  LabelText,
  DropDown,
  Input,
  CopyableHash,
  ExternalLink,
} from '@zen-common/components-base';
import { TechnicalData as TD } from '@zen/common-app-parts';

export default function OraclesDropDown({ items, value, onChange }) {
  return (
    <FormGroup mb="smd">
      <Label>
        <LabelText>Oracle Service Provider</LabelText>
      </Label>
      {items.length > 1 ? (
        <DropDown items={items} onChange={onChange} value={(value || {}).address} />
      ) : (
        <Input inputType="expandable" readOnly variant="block" value={(value || {}).address} />
      )}

      {value && (
        <Box mt="2" mb="smd">
          <TD.Section>
            <Box>
              <TD.Label>Data Source:</TD.Label>
              <TD.Value>
                <ExternalLink href={value.dataSourceUrl}>
                  {value.dataSource} {value.dataSourceUrl}
                </ExternalLink>
              </TD.Value>
            </Box>
            <Box>
              <TD.Label>Committed Data:</TD.Label>
              <TD.Value>SP500 EOD</TD.Value>
            </Box>
            <Box>
              <TD.Label>Oracle PublicKey:</TD.Label>
              <TD.Value>
                <CopyableHash hash={value.publicKey} />
              </TD.Value>
            </Box>
          </TD.Section>
        </Box>
      )}
    </FormGroup>
  );
}
